const API_HOST = '';
export const ApiKey = '4011DE4CB07440DBB8497DB447835153';

export default API_HOST;
